import * as React from "react";
import { forwardRef } from "react";
const SvgUiArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={5} height={6} viewBox="0 0 5 6" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M0.5 3L5 0V6z" fill="currentColor" fillRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgUiArrowLeft);
export { ForwardRef as ReactComponent };